import { gql } from "graphql-request";

const SERVER_DELETE_USER_CONTRACT = gql`
  mutation SERVER_DeleteUserContract($id: ID!) {
    deleteUserContract(id: $id)
  }
`;
export default SERVER_DELETE_USER_CONTRACT;
